import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import ClientConfig from 'client/config';
import { IUser } from 'common/interfaces/customer-interfaces';

const user = createSlice({
  name: 'user',
  initialState: {
    isLoading: false,
    user: null as IUser | null,
    users: [] as IUser[],
    error: null,
  },
  reducers: {
    userRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    userRecieved: (state, action) => {
      state.isLoading = false;
      state.user = action.payload;
    },
    usersRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    usersRecieved: (state, action) => {
      state.isLoading = false;
      state.users = action.payload;
    },
    usersFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
});

export const {
  userRequested,
  userRecieved,
  usersRequested,
  usersRecieved,
  usersFailed,
} = user.actions;

export default user.reducer;

export const getUserInfo = () => apiCallBegan({
  url: `${ClientConfig.config.customerAdminBaseUrl}/adm/api/user-info`,
  method: 'GET',
  onStart: userRequested.type,
  onSuccess: (response: IUser) => ({
    type: userRecieved.type,
    payload: response,
  }),
  onError: usersFailed.type,
});

export const getUsers = () => apiCallBegan({
  url: '/archive/customer-users',
  method: 'GET',
  onStart: usersRequested.type,
  onSuccess: (response: { customerUsers: IUser[] }) => ({
    type: usersRecieved.type,
    payload: response.customerUsers,
  }),
  onError: usersFailed.type,
});
